import {
    VIDEO_PLAYER_CREATE_FAIL,
    VIDEO_PLAYER_CREATE_REQUEST,
    VIDEO_PLAYER_CREATE_RESET,
    VIDEO_PLAYER_CREATE_SUCCESS,
    VIDEO_PLAYER_DELETE_FAIL,
    VIDEO_PLAYER_DELETE_REQUEST,
    VIDEO_PLAYER_DELETE_RESET,
    VIDEO_PLAYER_DELETE_SUCCESS,
    VIDEO_PLAYER_DETAILS_FAIL,
    VIDEO_PLAYER_DETAILS_REQUEST,
    VIDEO_PLAYER_DETAILS_SUCCESS,
    VIDEO_PLAYER_LIST_FAIL,
    VIDEO_PLAYER_LIST_REQUEST,
    VIDEO_PLAYER_LIST_SUCCESS,
    VIDEO_PLAYER_LOG_DATES_FAIL,
    VIDEO_PLAYER_LOG_DATES_REQUEST,
    VIDEO_PLAYER_LOG_DATES_SUCCESS, VIDEO_PLAYER_LOG_FOR_DATE_FAIL, VIDEO_PLAYER_LOG_FOR_DATE_REQUEST,
    VIDEO_PLAYER_LOG_FOR_DATE_SUCCESS, VIDEO_PLAYER_RESTART_FAIL, VIDEO_PLAYER_RESTART_REQUEST, VIDEO_PLAYER_RESTART_SUCCESS,
    VIDEO_PLAYER_UPDATE_DETAILS_FAIL,
    VIDEO_PLAYER_UPDATE_DETAILS_REQUEST,
    VIDEO_PLAYER_UPDATE_DETAILS_RESET,
    VIDEO_PLAYER_UPDATE_DETAILS_SUCCESS
} from '../constants/videoPlayerConstants';

export const videoPlayerListReducer = (state = {videoPlayers: []}, action) => {
    switch (action.type) {
        case VIDEO_PLAYER_LIST_REQUEST:
            return {loading: true, videoPlayers: []};
        case VIDEO_PLAYER_LIST_SUCCESS:
            return {loading: false, videoPlayers: action.payload};
        case VIDEO_PLAYER_LIST_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
};

export const videoPlayerCreateReducer = (state = {}, action) => {
    switch(action.type){
        case VIDEO_PLAYER_CREATE_REQUEST:
            return {loading: true};
        case VIDEO_PLAYER_CREATE_SUCCESS:
            return {loading: false, videoPlayer: action.payload};
        case VIDEO_PLAYER_CREATE_FAIL:
            return {loading: false, error: action.payload};
        case VIDEO_PLAYER_CREATE_RESET:
            return {loading: false, error: null};
        default:
            return state;
    }
};

export const videoPlayerDetailsReducer = (state = {videoPlayer: {}}, action) => {
    switch (action.type) {
        case VIDEO_PLAYER_DETAILS_REQUEST:
            return {...state, loading: true};
        case VIDEO_PLAYER_DETAILS_SUCCESS:
            return {loading: false, videoPlayer: action.payload};
        case VIDEO_PLAYER_DETAILS_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
};

export const videoPlayerUpdateDetailsReducer = (state = {videoPlayer: {}}, action) => {
    switch (action.type) {
        case VIDEO_PLAYER_UPDATE_DETAILS_REQUEST:
            return {loading: true};
        case VIDEO_PLAYER_UPDATE_DETAILS_SUCCESS:
            return {loading: false, success: true, videoPlayer: action.payload};
        case VIDEO_PLAYER_UPDATE_DETAILS_FAIL:
            return {loading: false, error: action.payload};
        case VIDEO_PLAYER_UPDATE_DETAILS_RESET:
            return {videoPlayer: {}};
        default:
            return state;
    }
};

export const videoPlayerDeleteReducer = (state = {success: false}, action) => {
    switch (action.type) {
        case VIDEO_PLAYER_DELETE_REQUEST:
            return {loading: true, ...state};
        case VIDEO_PLAYER_DELETE_SUCCESS:
            return {loading: false, success: true};
        case VIDEO_PLAYER_DELETE_FAIL:
            return {loading: false, success: false, error: action.payload};
        case VIDEO_PLAYER_DELETE_RESET:
            return {loading: false, success: false, error: null};
        default:
            return state;
    }
};

export const videoPlayerLogDatesReducer = (state = { dates: [] }, action) => {
    switch (action.type){
        case VIDEO_PLAYER_LOG_DATES_REQUEST:
            return {loading: true, dates: [], error: null};
        case VIDEO_PLAYER_LOG_DATES_SUCCESS:
            return {loading: false, dates: action.payload, error: null};
        case VIDEO_PLAYER_LOG_DATES_FAIL:
            return {loading: false, dates: [], error: action.payload};
        default:
            return state;
    }
};

export const videoPlayerLogForDateReducer = (state = { logs: {} }, action) => {
    switch (action.type){
        case VIDEO_PLAYER_LOG_FOR_DATE_REQUEST:
            return {loading: true, logs: {}, error: null};
        case VIDEO_PLAYER_LOG_FOR_DATE_SUCCESS:
            return {loading: false, logs: action.payload, error: null};
        case VIDEO_PLAYER_LOG_FOR_DATE_FAIL:
            return {loading: false, logs: {}, error: action.payload};
        default:
            return state;
    }
};

export const videoPlayerRestartReducer = (state = {}, action) => {
    switch (action.type) {
        case VIDEO_PLAYER_RESTART_REQUEST:
            return {loading: true};
        case VIDEO_PLAYER_RESTART_SUCCESS:
            return {loading: false};
        case VIDEO_PLAYER_RESTART_FAIL:
            return {loading: false, error: action.payload};
        default:
            return state;
    }
};
